import React, { useState } from "react";
import {
  Box,
  Typography,
  Modal,
  IconButton,
  Tooltip,
  CircularProgress,
  Button,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import {
  Close,
  HttpOutlined,
  ContentCopy,
  Check,
  Visibility,
  VisibilityOff,
  OpenInNew,
  WarningAmber,
} from "@mui/icons-material";

export default function ModalAcessoHttp({ open, onClose, data, hostName }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [copiedField, setCopiedField] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleCopy = (value, fieldName) => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    setCopiedField(fieldName);
    setTimeout(() => {
      setCopiedField(null);
    }, 2000);
  };

  const handleOpenUrl = (url) => {
    if (!url) return;
    let finalUrl = url;
    if (!finalUrl.startsWith("http://") && !finalUrl.startsWith("https://")) {
      finalUrl = "http://" + finalUrl;
    }
    window.open(finalUrl, "_blank", "noopener,noreferrer");
  };

  const renderCard = (label, value, fieldName, isUrl = false, isPassword = false) => {
    const isCopied = copiedField === fieldName;

    return (
      <Box sx={styles.card}>
        <Typography sx={styles.cardLabel}>{label}</Typography>
        <Tooltip title={isUrl ? "Abrir em nova aba" : "Copiar"}>
          <Box
            sx={styles.cardContent}
            onClick={() => {
              if (isUrl) {
                handleOpenUrl(value);
              } else {
                handleCopy(value, fieldName);
              }
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", overflow: "hidden", flex: 1 }}>
              <Typography sx={styles.cardValue}>
                {isPassword && !showPassword
                  ? "••••••••"
                  : value || "Não configurado"}
              </Typography>
            </Box>
            
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {isPassword && value && (
                <IconButton
                  size="small"
                  sx={styles.iconButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowPassword(!showPassword);
                  }}
                >
                  {showPassword ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              )}
              {value && (
                <IconButton size="small" sx={styles.iconButton}>
                  {isCopied ? (
                    <Check fontSize="small" color="success" />
                  ) : isUrl ? (
                    <OpenInNew fontSize="small" color="primary" />
                  ) : (
                    <ContentCopy fontSize="small" color="primary" />
                  )}
                </IconButton>
              )}
            </Box>
          </Box>
        </Tooltip>
      </Box>
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-acesso-http-title"
    >
      <Box sx={styles.modalBox}>
        {/* Header */}
        <Box sx={styles.header}>
          <Box sx={styles.title}>
            <HttpOutlined color="primary" />
            <Typography variant="h6" component="h2" fontSize="1.1rem" fontWeight="bold">
              Acesso HTTP
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          <strong>Host:</strong> {hostName || "Desconhecido"}
        </Typography>

        {/* Content */}
        {data?.loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress size={30} />
          </Box>
        ) : !data?.url ? (
          <Box sx={styles.emptyState}>
            <WarningAmber sx={{ fontSize: 40, color: "warning.main", mb: 1 }} />
            <Typography variant="body1" fontWeight="bold">
              Sem configuração HTTP
            </Typography>
            <Typography variant="body2" align="center" mt={1}>
              As credenciais de acesso HTTP não foram cadastradas para este host.
            </Typography>
          </Box>
        ) : (
          <>
            {renderCard("URL de Acesso", data?.url, "url", true, false)}
            {renderCard("Usuário", data?.user, "user", false, false)}
            {renderCard("Senha", data?.pass, "pass", false, true)}
          </>
        )}

        {/* <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
          <Button variant="outlined" onClick={onClose} size="small">
            Fechar
          </Button>
        </Box> */}
      </Box>
    </Modal>
  );
}
